module.exports = "/_next/static/images/big@2x-796f01f0e44e9ad99cfd7c2b37bdd538.png";